//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';
import { Options } from 'highcharts';

export const CHART_COLORS = {
  // Greyscale
  '@marshmallow': '#f7f7f7',
  '@mushroom': '#e3e3e3',
  '@oyster': '#7e7e7e',
  '@oreo': '#3e3e3e',
  '@gray6': '#9ba0a5',
  '@gray7': '#868B8F',
  '@gray9': '#47494b',

  // Accent Colors
  '@mint3': '#81e2d2',
  '@mint7': '#009e89',
  '@cyan3': '#97dbe9',
  '@indigo3': '#e8c3fd',

  // Misc
  '@guacamole': '#18ae8f',
  // This is called pumpkin for legacy reasons. It should map to our primary color
  '@pumpkin': theme.colors.aliases.primary,
};

export function mergeOptions(...args: Options[]): Options {
  return $.extend.apply(undefined, [true, {}, ...args]);
}
